<template>
  <div class="about">
    <div class="banner" :style="{ background: 'linear-gradient(120deg, #E0EAF4, #B5C8DC)' }">
      <div class="container">
        <div class="banner-content">
          <h1>关于我们</h1>
          <p>上海臻晅信息科技有限公司</p>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="company-intro">
          <div class="intro-content">
            <h2>公司简介</h2>
            <p>
              上海臻晅信息科技有限公司是一家专注于教育信息化的高科技企业，致力于为教育局与学校提供多方位的信息化解决方案。我们拥有一支由技术专家和教育领域顾问组成的专业团队，深入理解教育行业需求，通过创新技术和优质服务，助力教育机构实现数字化转型，提升管理效率和教学质量。
            </p>
            <p>
              自成立以来，我们已为很多所中小学校、教育局、企业提供优质技术支持服务，产品覆盖教育管理、教学应用、学生发展等多个领域，深受客户好评。我们秉持"科技赋能教育，创新驱动未来"的理念，不断探索教育信息化的新模式、新应用，为教育现代化贡献力量。
            </p>
          </div>
          <div class="intro-image" :style="{ backgroundColor: '#f5f7fa' }">
            <i class="el-icon-school"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="section bg-light">
      <div class="container">
        <h2 class="section-title">我们的使命</h2>
        <p class="section-subtitle">
          通过创新技术赋能教育，促进教育公平，提升教育质量，助力每一个教育工作者和学习者实现更好的教与学。
        </p>
        <div class="mission-vision">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12">
              <div class="mission-card">
                <div class="card-icon">
                  <i class="el-icon-aim"></i>
                </div>
                <h3>愿景</h3>
                <p>成为教育信息化领域的引领者，打造最受信赖的教育信息化服务品牌。</p>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12">
              <div class="mission-card">
                <div class="card-icon">
                  <i class="el-icon-star-off"></i>
                </div>
                <h3>价值观</h3>
                <p>以客户为中心、追求卓越、拥抱创新、协作共赢、诚信负责。</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <h2 class="section-title">我们的优势</h2>
        <p class="section-subtitle">凭借专业团队和丰富经验，为教育机构提供卓越的信息化解决方案</p>

        <div class="advantages-intro">
          <p>我们坚信，<span class="highlight">技术创新</span>与<span class="highlight">教育专业</span>的深度融合是推动教育现代化的关键。我们的团队不仅具备领先的技术能力，更深入理解教育行业的实际需求，通过创新解决方案助力教育机构提升管理效率和教学质量。</p>
        </div>

        <div class="advantages-wrapper">
          <div class="advantages-bg"></div>
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :md="8" v-for="(advantage, index) in advantages" :key="index">
              <div class="advantage-card">
                <div class="advantage-header">
                  <div class="advantage-icon">
                    <i :class="advantage.icon"></i>
                  </div>
                </div>
                <h3>{{advantage.title}}</h3>
                <p>{{advantage.description}}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="section bg-light">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <div class="timeline">
          <el-timeline>
            <el-timeline-item timestamp="2017年" placement="top" color="#409EFF">
              <el-card>
                <h4>公司成立</h4>
                <p>公司在上海成立，开始专注于教育信息化领域的探索与实践。</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2018年" placement="top" color="#67C23A">
              <el-card>
                <h4>首款产品上线</h4>
                <p>成功推出学生资助系统、项目申报系统，获得教育局采用。</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2020年" placement="top" color="#E6A23C">
              <el-card>
                <h4>教育产品体系形成</h4>
                <p>陆续推出资产系统、人事系统等多款教育局产品，形成完整的教育局解决方案。</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2022年" placement="top" color="#F56C6C">
              <el-card>
                <h4>学校产品线拓展</h4>
                <p>开始拓展学校产品线，推出成绩分析系统、教师在线学习平台、学生活动平台等产品。</p>
              </el-card>
            </el-timeline-item>
<!--            <el-timeline-item timestamp="2025年" placement="top" color="#909399">-->
<!--              <el-card>-->
<!--                <h4>全国布局完成</h4>-->
<!--                <p>在全国主要城市设立服务网点，完成全国布局。</p>-->
<!--              </el-card>-->
<!--            </el-timeline-item>-->
            <el-timeline-item timestamp="2025年" placement="top" color="#409EFF">
              <el-card>
                <h4>智能化升级</h4>
                <p>深度升级产品，融入人工智能、大数据等技术，提升产品智能化水平。</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <p class="section-subtitle">我们与众多知名企业和机构建立了长期稳定的合作关系</p>
        <div class="partners">
          <el-row :gutter="30">
            <el-col :xs="12" :sm="8" :md="4" v-for="i in 12" :key="i">
              <div class="partner-logo" :style="{ backgroundColor: '#f5f7fa' }">
                <img :src="require(`@/assets/images/partner${i}.png`)" alt="合作伙伴" />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>



    <div class="section bg-light">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">如有任何问题或需求，欢迎随时与我们联系</p>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8">
            <div class="contact-card">
              <i class="el-icon-location"></i>
              <h3>公司地址</h3>
              <p>上海市嘉定区德富路1090号宝龙广场5号楼502室</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <div class="contact-card">
              <i class="el-icon-phone"></i>
              <h3>联系电话</h3>
              <p>13671549886</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <div class="contact-card">
              <i class="el-icon-message"></i>
              <h3>电子邮箱</h3>
              <p>contact@schoolsoft.cn</p>
            </div>
          </el-col>
        </el-row>
        <div class="contact-action">
          <el-button type="primary" size="large" @click="$router.push('/contact')">立即联系我们</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      advantages: [
        {
          icon: 'el-icon-user',
          title: '专业团队',
          description: '由资深技术专家和教育领域顾问组成的专业团队，拥有丰富的项目经验和行业积累，能够深入理解教育行业需求。'
        },
        {
          icon: 'el-icon-data-analysis',
          title: '创新技术',
          description: '持续关注前沿技术发展，将云计算、大数据、人工智能等技术与教育场景深度融合，提供创新解决方案。'
        },
        {
          icon: 'el-icon-cpu',
          title: '产品体系',
          description: '构建完整的教育信息化产品体系，覆盖教育管理、教学应用、学生发展等多个领域，满足各类教育机构需求。'
        },
        {
          icon: 'el-icon-connection',
          title: '行业经验',
          description: '深耕教育行业多年，深入理解教育机构需求，为数百家教育机构提供成功的信息化解决方案和持续的技术支持。'
        },
        {
          icon: 'el-icon-service',
          title: '优质服务',
          description: '提供从咨询、实施到培训、运维的全方位服务，建立完善的售后体系，确保系统高效稳定运行与用户满意。'
        },
        {
          icon: 'el-icon-coordinate',
          title: '全国布局',
          description: '在全国主要城市设有服务网点，拥有快速响应的服务团队，可为客户提供及时、便捷的本地化技术支持与服务。'
        }
      ]
    };
  }
}
</script>

<style scoped>
.banner {
  padding: 70px 0;
  color: #2C3E50;
  margin-bottom: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}
.banner-content {
  text-align: center;
  position: relative;
  z-index: 2;
}
.banner-content h1 {
  font-size: 2.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
}
.banner-content p {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  font-weight: 300;
}

.bg-light {
  background-color: #f8f9fa;
}

.company-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
}
.intro-content {
  flex: 1;
  min-width: 300px;
}
.intro-content h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 1.8rem;
}
.intro-content p {
  margin-bottom: 20px;
  color: #666;
  line-height: 1.8;
}
.intro-image {
  flex: 1;
  min-width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.intro-image i {
  font-size: 6rem;
  color: #1976D2;
}

.mission-vision {
  margin-top: 40px;
}
.mission-card {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  height: 100%;
}
.card-icon {
  width: 80px;
  height: 80px;
  background-color: #1976D2;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}
.card-icon i {
  font-size: 2.5rem;
}
.mission-card h3 {
  margin-bottom: 15px;
  color: #333;
  font-size: 1.5rem;
}
.mission-card p {
  color: #666;
  line-height: 1.6;
}

.advantages-intro {
  max-width: 800px;
  margin: 0 auto 40px;
  text-align: center;
  padding: 0 15px;
}

.advantages-intro p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
}

.highlight {
  color: #1976D2;
  font-weight: 600;
  position: relative;
}

.highlight:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background-color: rgba(25, 118, 210, 0.1);
  z-index: -1;
}

.advantages-wrapper {
  position: relative;
  padding: 20px 0;
  margin-top: 30px;
}

.advantages-bg {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: 75%;
  background: linear-gradient(180deg, rgba(25, 118, 210, 0.05), rgba(25, 118, 210, 0));
  border-radius: 15px;
  z-index: -1;
}

@media (max-width: 991px) {
  .advantages-bg {
    height: 85%;
  }
}

@media (max-width: 767px) {
  .advantages-bg {
    height: 90%;
  }
}

/* 确保每行显示三个卡片 */
.advantages-wrapper .el-row {
  display: flex;
  flex-wrap: wrap;
}

.advantages-wrapper .el-col {
  display: flex;
  margin-bottom: 30px;
}

.advantage-card {
  background-color: white;
  padding: 30px 25px;
  border-radius: 12px;
  text-align: left;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  width: 100%;
  min-height: 280px;
  transition: all 0.4s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.advantage-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(25, 118, 210, 0.1);
  border-color: rgba(25, 118, 210, 0.2);
}

.advantage-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 0;
  background-color: #1976D2;
  transition: height 0.3s ease;
}

.advantage-card:hover:before {
  height: 100%;
}

.advantage-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  height: 64px;
}

.advantage-icon {
  width: 64px;
  height: 64px;
  background-color: #1976D2;
  color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
  transition: all 0.3s ease;
  box-shadow: 0 6px 15px rgba(25, 118, 210, 0.2);
}

.advantage-card:hover .advantage-icon {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.3);
}

.advantage-icon i {
  font-size: 2rem;
}

.advantage-number {
  display: none;
}

.advantage-card h3 {
  margin-bottom: 12px;
  color: #2C3E50;
  font-size: 1.4rem;
  font-weight: 600;
  transition: color 0.3s ease;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* 确保所有卡片标题宽度一致 */
.advantages-wrapper .el-col:nth-child(1) .advantage-card h3,
.advantages-wrapper .el-col:nth-child(2) .advantage-card h3,
.advantages-wrapper .el-col:nth-child(3) .advantage-card h3,
.advantages-wrapper .el-col:nth-child(4) .advantage-card h3,
.advantages-wrapper .el-col:nth-child(5) .advantage-card h3,
.advantages-wrapper .el-col:nth-child(6) .advantage-card h3 {
  width: 100%;
}

.advantage-card:hover h3 {
  color: #1976D2;
}

.advantage-card p {
  color: #555;
  line-height: 1.7;
  font-size: 1rem;
  flex-grow: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  height: 8.5em;
  margin-bottom: 0;
}

/* 针对小屏幕进行优化 */
@media (max-width: 767px) {
  .advantage-card {
    min-height: 220px;
  }

  .advantage-card p {
    -webkit-line-clamp: 4;
    height: 6.8em;
  }
}

.timeline {
  padding: 20px 0;
}

.partners {
  margin-top: 40px;
}
.partner-logo {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-bottom: 20px;
  font-weight: bold;
  color: #999;
}

.contact-card {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  height: 100%;
}
.contact-card i {
  font-size: 2.5rem;
  color: #3498DB;
  margin-bottom: 15px;
}
.contact-card h3 {
  margin-bottom: 10px;
  color: #333;
  font-size: 1.3rem;
}
.contact-card p {
  color: #666;
}
.contact-action {
  text-align: center;
  margin-top: 30px;
}

@media (max-width: 767px) {
  .advantages-intro p {
    font-size: 1rem;
    line-height: 1.7;
  }

  .section-subtitle {
    padding: 0 15px;
  }
}
.partners {
  margin-top: 40px;
}

.partner-logo {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin-bottom: 30px;
  padding: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.partner-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.partner-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

@media (max-width: 767px) {
  .partner-logo {
    height: 80px;
    margin-bottom: 20px;
  }
}
</style>
